$(function() {
  // position: fixed で固定しているので、ヘッダーの高さ(+余裕)分だけコンテンツを下げる
  var height = $("#masthead.site-header-sticky").height();
  $("body").css("margin-top", height);
});
